<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_product"
        :columns="columns"
        :mod-count="modCount"
        :offset-height="offsetHeight"
        :url="url"
        :show-column-visible="true"
        :search-form-fields="formFields"
        @on-add="showFormModalDialog"
      />
    </div>
    <ProductDialog
      :id="entityId"
      :visible="modalForm"
      :width="500"
      :action="url"
      @on-close="onModalClose"
    />
    <!-- <ProductItemListDialog
      :product-id="entityId"
      :visible="modalItemList"
      caption="产品定价"
      :width="990"
      :action="subUrl"
      @on-close="onModalClose"
    /> -->
  </div>
</template>

<script>
import ProductDialog from './dialog/productDialog'
import TableWrapper from '@/components/table-wrapper'
import request from '@/utils/request'
export default {
  name: 'ProductList',
  components: {
    TableWrapper, ProductDialog
  },
  data() {
    return {
      entityId: 0,
      modCount: 0,
      modalForm: false,
      modalItemList: false,
      url: this.$config.apiContextPath + '/product',
      subUrl: '',
      action: ''
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '产品名', placeholder: '请输入产品名...', name: 'name', width: 'auto', type: 'input' },
          { label: '产品域', placeholder: '请输入产品域...', name: 'namespace', width: 'auto', type: 'input' }
        ]
      }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '产品名', align: 'left', key: 'name', sortable: true, ellipsis: true, tooltip: true },
        { title: '产品域', align: 'left', key: 'namespace', sortable: true, ellipsis: true, tooltip: true },
        { title: '产品备注', align: 'left', key: 'remarks', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.remarks || '---')
          }
        },
        { title: '创建时间', align: 'center', key: 'createTime', sortable: true, width: 160, ellipsis: true, tooltip: true },
        { title: '更新时间', align: 'center', key: 'updateTime', sortable: true, width: 160, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.updateTime || '---')
          }
        },
        { title: '操作', align: 'center', width: 185, key: '_actions', disabled: true,
          render: (h, params) => {
            return h('div', [
              // h('a', {
              //   style: { color: '#126D91', marginRight: '10px' },
              //   on: {
              //     click: () => {
              //       if (params.row.id) {
              //         this.showProductItemModalDialog(params.row.id)
              //       }
              //     }
              //   }
              // }, [
              //   h('i', { class: { 'fas': true, 'fa-donate': true, 'cell-icon-link': true }}),
              //   h('span', {}, '定价')
              // ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ])
            ])
          }
        }]
    }
  },
  methods: {
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      this.modalItemList = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    showProductItemModalDialog: function(id) {
      this.entityId = id ? parseInt(id) : 0
      this.modalItemList = true
      this.subUrl = this.url + '/' + this.entityId + '/item'
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除`' + name + '`产品么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '产品 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '产品 `' + name + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    }
  }
}
</script>

